import React, { useEffect, useState } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from "../../assets/img/logo.png";

//MUI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  Tooltip,
  Typography,
  Menu,
  MenuItem,
  Badge,
  Divider
} from "@mui/material";
import Cancel from "@mui/icons-material/Cancel";
import { setToast } from "../../util/toast";

//axios//Alert

import axios from "axios";
import { projectName, baseURL } from "../../util/config";
import io from "socket.io-client";


const handelToggle = () => {
  $("html").toggleClass("sidebar-noneoverflow");
  $("body").toggleClass("sidebar-noneoverflow");
  $(".navbar-expand-sm").toggleClass("expand-header");
  $(".main-container")?.toggleClass("sidebar-closed sbar-open");
};

const Navbar = () => {
  
  const { admin } = useSelector((state) => state.admin);
  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState([]);
  const [imageData, setImageData] = useState(null);
  const [imagePath, setImagePath] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [errors, setError] = useState({
    title: "",
    image: "",
    description: "",
    type: "",
  });

  const [adminNotifs, setAdminNotifs] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const notifMenuOpen = Boolean(anchorEl);

  // Send Notification extra states
  const [sendMode, setSendMode] = useState("all"); // 'all' | 'multiple'
  const [userList, setUserList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [listLoading, setListLoading] = useState(false);


  useEffect(() => {
    // Fetch initial notifications
    fetchAdminNotifs();

    // Setup Socket - auto-detect local vs production
    const socketURL = window.location.hostname === "localhost"
      ? "http://localhost:5001"
      : baseURL;
    const socket = io(socketURL, {
      transports: ["websocket", "polling"],
    });
    socket.on("adminNotification", (data) => {
      setToast("info", data.message);
      setAdminNotifs((prev) => [data, ...prev]);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const fetchAdminNotifs = () => {
    axios.get("adminNotification").then((res) => {
      if (res.data.status) {
        setAdminNotifs(res.data.notifications || []);
      }
    }).catch(console.error);
  };

  const handleNotifClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotifClose = () => {
    setAnchorEl(null);
  };

  const removeNotif = (id) => {
    axios.delete(`adminNotification/${id}`).then((res) => {
      if (res.data.status) {
        setAdminNotifs((prev) => prev.filter((n) => n._id !== id && n.notificationId !== id));
      }
    }).catch(console.error);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleInputImage = (e) => {
    if (e.target.files[0]) {
      setImageData(e.target.files[0]);
      const reader = new FileReader();

      reader.addEventListener("load", () => {
        setImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setError({ title: "", image: "", description: "", type: "" });
    setTitle("");
    setDescription("");
    setImageData(null);
    setImagePath(null);
    setSendMode("all");
    setSelectedUsers([]);
    setUserSearch("");
    setUserList([]);
    $("#file").val("");
  };

  // Fetch user/host list when type changes
  const handleTypeChange = (val) => {
    setType(val);
    setSendMode("all");
    setSelectedUsers([]);
    setUserList([]);
    setUserSearch("");
    setListLoading(false);
    if (val === "user") {
      setListLoading(true);
      // userGet returns { status, userAll: [...] }
      axios.get("user/userGet?limit=500").then((res) => {
        if (res.data.status) {
          setUserList(res.data.userAll || []);
        }
      }).catch(console.error).finally(() => setListLoading(false));
    } else if (val === "host") {
      setListLoading(true);
      // hostGet returns { status, host: [...] }
      axios.get("host/?limit=500").then((res) => {
        if (res.data.status) {
          setUserList(res.data.host || []);
        }
      }).catch(console.error).finally(() => setListLoading(false));
    }
  };

  const toggleSelectUser = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const filteredList = userList.filter((u) => {
    const name = (u.name || u.email || "").toLowerCase();
    return name.includes(userSearch.toLowerCase());
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = {};
    if (!title) errs.title = "Title can't be blank!";
    if (!description) errs.description = "Description can't be blank!";
    if (!type || type === "Select Type") errs.type = "Please select type!";
    if (sendMode === "multiple" && selectedUsers.length === 0) {
      errs.type = "Please select at least one recipient!";
    }
    if (Object.keys(errs).length > 0) return setError({ ...errors, ...errs });

    setError({ title: "", image: "", description: "", type: "" });

    const formData = new FormData();
    if (imageData) formData.append("image", imageData);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("notificationType", type);
    if (sendMode === "multiple" && selectedUsers.length > 0) {
      selectedUsers.forEach((id) => formData.append("userIds[]", id));
    }

    axios
      .post("notification/sendNotification", formData)
      .then((res) => {
        if (res.data.status === true) {
          setToast("success", "Notification sent successfully!");
          handleClose();
        } else {
          setToast("error", res.data.message || "Failed to send");
        }
      })
      .catch((error) => {
        console.log(error);
        setToast("error", "Something went wrong!");
      });
  };

  return (
    <>
      <div class="sub-header-container fixed-top">
        <header class="header navbar navbar-expand-sm align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <a
              href={() => false}
              class="sidebarCollapse"
              data-placement="bottom"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-menu"
                onClick={handelToggle}
              >
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </a>

            <div class="page-header">
              <nav class="breadcrumb-one" aria-label="breadcrumb">
                <Link to="/admin/dashboard">
                  <ol class="breadcrumb ">
                    <li class="breadcrumb-item">
                      <a
                        href={() => false}
                        style={{
                          color: "#e8538f",
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        <div className="navLogo">
                          <span style={{ marginRight: "5px" }}>
                            <img src={logo} alt="" width={35} height={35} />
                          </span>
                          <span>{projectName}</span>
                        </div>
                      </a>
                    </li>
                  </ol>
                </Link>
              </nav>
            </div>
          </div>

          <div>
            <ul class="navbar-nav flex-row ml-auto">
              {/* Send Notification Button */}
              <li class="nav-item dropdown notification-dropdown mr-1">
                <Tooltip title="Send Notification to Users/Hosts">
                  <a
                    href={() => false}
                    class="nav-link dropdown-toggle noti"
                    onClick={handleClickOpen}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send">
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                  </a>
                </Tooltip>
              </li>

              {/* View Admin Notifications Bell */}
              <li class="nav-item dropdown notification-dropdown mr-1">
                <a
                  href={() => false}
                  class="nav-link dropdown-toggle noti"
                  onClick={handleNotifClick}
                  style={{ position: "relative" }}
                >
                  <Badge badgeContent={adminNotifs.length} color="error" max={99}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-bell"
                    >
                      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                  </Badge>
                </a>
                <Menu
                  anchorEl={anchorEl}
                  open={notifMenuOpen}
                  onClose={handleNotifClose}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  PaperProps={{
                    style: {
                      maxHeight: 450,
                      width: "370px",
                      marginTop: "8px",
                      borderRadius: "12px",
                      background: "#1a1a2e",
                      border: "1px solid rgba(255,255,255,0.1)",
                      boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                      overflow: "hidden",
                    },
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      padding: "14px 18px",
                      background: "linear-gradient(135deg, #e8538f, #664dc9)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                      </svg>
                      <span style={{ color: "white", fontWeight: "700", fontSize: "15px" }}>
                        Admin Notifications
                      </span>
                    </div>
                    {adminNotifs.length > 0 && (
                      <span
                        style={{
                          background: "rgba(255,255,255,0.25)",
                          color: "white",
                          borderRadius: "20px",
                          padding: "2px 10px",
                          fontSize: "12px",
                          fontWeight: "600",
                        }}
                      >
                        {adminNotifs.length} new
                      </span>
                    )}
                  </div>

                  {/* Notification List */}
                  <div style={{ overflowY: "auto", maxHeight: "360px" }}>
                    {adminNotifs.length === 0 ? (
                      <div
                        style={{
                          padding: "40px 20px",
                          textAlign: "center",
                          color: "rgba(255,255,255,0.4)",
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: "10px" }}>
                          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                        </svg>
                        <div style={{ fontSize: "14px" }}>No new notifications</div>
                      </div>
                    ) : (
                      adminNotifs.map((notif, index) => {
                        const typeColorMap = {
                          MANUAL_PAYMENT_REQUEST: { bg: "#e8538f22", border: "#e8538f", icon: "💳" },
                          HOST_REQUEST: { bg: "#664dc922", border: "#664dc9", icon: "🎤" },
                          REDEEM_REQUEST: { bg: "#f7971e22", border: "#f7971e", icon: "💰" },
                          DEFAULT: { bg: "#ffffff11", border: "#ffffff33", icon: "🔔" },
                        };
                        const style = typeColorMap[notif.type] || typeColorMap["DEFAULT"];

                        return (
                          <div key={index}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                padding: "12px 14px",
                                gap: "12px",
                                background: style.bg,
                                borderLeft: `3px solid ${style.border}`,
                                transition: "background 0.2s",
                                cursor: "default",
                              }}
                            >
                              {/* Icon */}
                              <div
                                style={{
                                  fontSize: "22px",
                                  minWidth: "36px",
                                  height: "36px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "rgba(255,255,255,0.08)",
                                  borderRadius: "8px",
                                }}
                              >
                                {style.icon}
                              </div>

                              {/* Content */}
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div
                                  style={{
                                    color: style.border,
                                    fontSize: "11px",
                                    fontWeight: "700",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    marginBottom: "3px",
                                  }}
                                >
                                  {notif.type?.replace(/_/g, " ")}
                                </div>
                                <div
                                  style={{
                                    color: "rgba(255,255,255,0.85)",
                                    fontSize: "13px",
                                    lineHeight: "1.4",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {notif.message}
                                </div>
                                {notif.date && (
                                  <div
                                    style={{
                                      color: "rgba(255,255,255,0.35)",
                                      fontSize: "11px",
                                      marginTop: "4px",
                                    }}
                                  >
                                    🕐 {notif.date}
                                  </div>
                                )}
                              </div>

                              {/* Remove button */}
                              <IconButton
                                size="small"
                                onClick={() => removeNotif(notif._id || notif.notificationId)}
                                style={{
                                  color: "rgba(255,255,255,0.3)",
                                  padding: "2px",
                                  flexShrink: 0,
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.color = "#e8538f")}
                                onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.3)")}
                              >
                                <Cancel fontSize="small" />
                              </IconButton>
                            </div>
                            {index < adminNotifs.length - 1 && (
                              <Divider style={{ borderColor: "rgba(255,255,255,0.05)", margin: 0 }} />
                            )}
                          </div>
                        );
                      })
                    )}
                  </div>
                </Menu>
              </li>

              <li class="nav-item more-dropdown ">
                <div class="dropdown  custom-dropdown-icon  ">
                  {/* <Link
                  class="dropdown-toggle btn"
                  data-value="Mail"
                  to="/admin/profile"
                >
                  Profile
                </Link> */}
                  <Link to="/admin/profile">
                    <img
                      src={admin?.image}
                      draggable="false"
                      style={{
                        width: "35px",
                        height: "35px",
                        borderRadius: "50px",
                        objectFit: "cover",
                        boxSizing: "border-box",
                      }}
                      alt=""
                    />
                  </Link>
                </div>
              </li>
            </ul>
          </div>
        </header>

        {/* ------------ Send Notification Dialog ------------- */}
        <Dialog
          open={open}
          aria-labelledby="send-notif-dialog"
          onClose={handleClose}
          fullWidth
          maxWidth="sm"
          style={{ zIndex: 9999999 }}
        >
          {/* Custom Header */}
          <div
            style={{
              background: "linear-gradient(135deg, #e8538f, #664dc9)",
              padding: "16px 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span style={{ color: "white", fontWeight: "700", fontSize: "17px" }}>
              📢 Send Notification
            </span>
            <IconButton size="small" onClick={handleClose} style={{ color: "white" }}>
              <Cancel />
            </IconButton>
          </div>

          <DialogContent style={{ padding: "20px 24px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

              {/* Title */}
              <div>
                <label style={{ fontWeight: "600", fontSize: "13px", marginBottom: "6px", display: "block" }}>Title *</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Notification title"
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                    if (!e.target.value) setError({ ...errors, title: "Title can't be blank!" });
                    else setError({ ...errors, title: "" });
                  }}
                />
                {errors.title && <Typography variant="caption" color="error">{errors.title}</Typography>}
              </div>

              {/* Description */}
              <div>
                <label style={{ fontWeight: "600", fontSize: "13px", marginBottom: "6px", display: "block" }}>Description *</label>
                <textarea
                  className="form-control"
                  placeholder="Notification message..."
                  rows={3}
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    if (!e.target.value) setError({ ...errors, description: "Description can't be blank!" });
                    else setError({ ...errors, description: "" });
                  }}
                />
                {errors.description && <Typography variant="caption" color="error">{errors.description}</Typography>}
              </div>

              {/* Notification Type */}
              <div>
                <label style={{ fontWeight: "600", fontSize: "13px", marginBottom: "6px", display: "block" }}>Notification Type *</label>
                <select
                  className="form-control"
                  value={type}
                  onChange={(e) => handleTypeChange(e.target.value)}
                >
                  <option value="">Select Type</option>
                  <option value="user">User</option>
                  <option value="host">Host</option>
                </select>
                {errors.type && <Typography variant="caption" color="error">{errors.type}</Typography>}
              </div>

              {/* Send Mode - All or Multiple (show after type selected) */}
              {type && (
                <div>
                  <label style={{ fontWeight: "600", fontSize: "13px", marginBottom: "8px", display: "block" }}>Send To *</label>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      type="button"
                      onClick={() => { setSendMode("all"); setSelectedUsers([]); }}
                      style={{
                        flex: 1,
                        padding: "10px",
                        border: `2px solid ${sendMode === "all" ? "#e8538f" : "#ddd"}`,
                        borderRadius: "8px",
                        background: sendMode === "all" ? "#e8538f11" : "transparent",
                        color: sendMode === "all" ? "#e8538f" : "#666",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.2s",
                      }}
                    >
                      🌐 All {type === "user" ? "Users" : "Hosts"}
                    </button>
                    <button
                      type="button"
                      onClick={() => setSendMode("multiple")}
                      style={{
                        flex: 1,
                        padding: "10px",
                        border: `2px solid ${sendMode === "multiple" ? "#664dc9" : "#ddd"}`,
                        borderRadius: "8px",
                        background: sendMode === "multiple" ? "#664dc911" : "transparent",
                        color: sendMode === "multiple" ? "#664dc9" : "#666",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.2s",
                      }}
                    >
                      👥 Select Multiple
                    </button>
                  </div>
                </div>
              )}

              {/* Multiple User Selector */}
              {type && sendMode === "multiple" && (
                <div
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  {/* Search */}
                  <div style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder={`Search ${type}...`}
                      value={userSearch}
                      onChange={(e) => setUserSearch(e.target.value)}
                    />
                  </div>
                  {/* Selected count */}
                  {selectedUsers.length > 0 && (
                    <div
                      style={{
                        padding: "6px 12px",
                        background: "#664dc911",
                        borderBottom: "1px solid #eee",
                        fontSize: "12px",
                        color: "#664dc9",
                        fontWeight: "600",
                      }}
                    >
                      ✅ {selectedUsers.length} selected
                    </div>
                  )}
                  {/* List */}
                  <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                    {listLoading ? (
                      <div style={{ padding: "20px", textAlign: "center", color: "#664dc9" }}>
                        <div style={{ fontSize: "13px", marginTop: "6px" }}>⏳ Loading {type === "user" ? "users" : "hosts"}...</div>
                      </div>
                    ) : filteredList.length === 0 ? (
                      <div style={{ padding: "16px", textAlign: "center", color: "#999", fontSize: "13px" }}>
                        {userSearch ? "No results found" : `No ${type === "user" ? "users" : "hosts"} available`}
                      </div>
                    ) : (
                      filteredList.map((u) => (
                        <div
                          key={u._id}
                          onClick={() => toggleSelectUser(u._id)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            padding: "8px 12px",
                            cursor: "pointer",
                            background: selectedUsers.includes(u._id) ? "#664dc911" : "transparent",
                            borderBottom: "1px solid #f0f0f0",
                            transition: "background 0.15s",
                          }}
                        >
                          <div
                            style={{
                              width: "18px",
                              height: "18px",
                              borderRadius: "4px",
                              border: `2px solid ${selectedUsers.includes(u._id) ? "#664dc9" : "#ccc"}`,
                              background: selectedUsers.includes(u._id) ? "#664dc9" : "transparent",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            {selectedUsers.includes(u._id) && (
                              <span style={{ color: "white", fontSize: "11px", fontWeight: "bold" }}>✓</span>
                            )}
                          </div>
                          <img
                            src={u.image || "https://via.placeholder.com/32"}
                            alt=""
                            style={{ width: "32px", height: "32px", borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
                            onError={(e) => { e.target.src = "https://via.placeholder.com/32"; }}
                          />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: "13px", fontWeight: "600", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {u.name || "Unknown"}
                            </div>
                            <div style={{ fontSize: "11px", color: "#999", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {(u.email && u.email.toLowerCase() !== "flirtzy@gmail.com") ? u.email : (u.mobileNo || "")}
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}

              {/* Image (Optional) */}
              <div>
                <label style={{ fontWeight: "600", fontSize: "13px", marginBottom: "6px", display: "block" }}>
                  Image <span style={{ color: "#999", fontWeight: "400" }}>(optional)</span>
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="customFile"
                  accept="image/*"
                  onChange={handleInputImage}
                />
                {imagePath && (
                  <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
                    <img
                      src={imagePath}
                      style={{
                        height: "60px",
                        width: "60px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "2px solid #e8538f",
                      }}
                      alt="preview"
                    />
                    <button
                      type="button"
                      style={{ background: "none", border: "none", color: "#e8538f", cursor: "pointer", fontSize: "12px" }}
                      onClick={() => { setImageData(null); setImagePath(null); $("#customFile").val(""); }}
                    >
                      ✕ Remove
                    </button>
                  </div>
                )}
              </div>

            </div>
          </DialogContent>

          {/* Footer with Send Button */}
          <DialogActions
            style={{
              padding: "12px 24px 20px",
              borderTop: "1px solid #eee",
              gap: "10px",
            }}
          >
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleClose}
              style={{ borderRadius: "8px", padding: "8px 20px" }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              style={{
                background: "linear-gradient(135deg, #e8538f, #664dc9)",
                border: "none",
                borderRadius: "8px",
                padding: "8px 28px",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <i className="ri-send-plane-fill"></i>
              Send{sendMode === "multiple" && selectedUsers.length > 0 ? ` (${selectedUsers.length})` : ""}
            </button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Navbar;
